import React from 'react';

export default function ArrowL() {
  return (
    <svg className="display-block" height="6" viewBox="0 0 10 6" width="10">
      <path d="M9.71,0.29a1,1,0,0,0-1.41,0L5,3.59,1.71,0.29A1,1,0,0,0,.29,1.71l4,4a1,1,0,0,0,1.41,0l4-4A1,1,0,0,0,9.71.29Z" />
    </svg>
  );
}



// WEBPACK FOOTER //
// ./packages/marvel-ui-select/icons/ArrowL.js